import {OnDestroy, OnInit} from '@angular/core';
import {AppStatus} from '../../@models/app-status';
import {StatusListener} from '../../status-listener';
import {OrderItem} from '../../../shared-gen/Model/Orders/OrderItem';
import {ProductBase} from '../../../shared-gen/Model/Products/ProductBase';
import {Product} from '../../../shared-gen/Model/Products/Product';
import {ProductFun} from '../../../shared/model/products/product.fun';
import {MenuFun} from '../../../shared/model/menus/menu.fun';
import {AppService} from '../../services/app.service';

export class PayingPageBase extends StatusListener implements OnInit, OnDestroy {

	cart: OrderItem[] = [];
	productBases: ProductBase[] = [];

	theme: string = "general";

	constructor(app: AppService) {
		super(app)
	}

	onStatusChanged(status: AppStatus) {
		super.onStatusChanged(status);

		if(!status.deviceStatus.VendingStatus.Order){
			console.log(status.deviceStatus.VendingStatus.Order);
			this.app.nav.openPageAndReportUserActivity(`/${this.theme}/menu/`);
			return;
		}
		this.cart = status.deviceStatus.VendingStatus.Order.Items;
	}

	async back() {
		await this.app.api.orderApi.cancel(true);
		this.app.nav.openPageAndReportUserActivity(`/${this.theme}/menu`)
	}

	findBase(product: Product): ProductBase {
		const baseID = ProductFun.getBaseID(product.ID);
		if (!this.productBases[baseID]) {
			this.productBases[baseID] = MenuFun.findProductBase(this.menu, product);
		}
		return this.productBases[baseID];
	}

	getImage(product: Product) {
		return this.app.api.dataApi.getImageUrl(this.findBase(product).Image);
	}
}
